/* Ayudate · Políticas: aviso al enviar y panel completo */

import React, { useState } from "react";
import { Capa } from "./Capa";

export const TEXTO_POLITICA = `No consensuamos ni apoyamos el uso de esta plataforma para solicitar la compra o venta de tareas, exámenes u otras actividades evaluativas. El objetivo es conectar a tutores con estudiantes para promover el aprendizaje de manera complementaria a la educación formal impartida por las universidades y demás centros de estudio. Instamos a los usuarios a respetar las normas y disposiciones de los institutos de educación donde estén matriculados.`;

export const TEXTO_ACOSO = `Política de Cero Tolerancia al Acoso y Convivencia Segura: En Ayudate nos comprometemos a mantener un entorno seguro, respetuoso y libre de cualquier forma de acoso, hostigamiento o conducta intimidatoria. La seguridad de nuestra comunidad estudiantil y de tutores es absoluta prioridad. Cualquier reporte de acoso sexual, comentarios inapropiados, conductas indebidas o violación a la integridad física o psicológica dentro o fuera de las sesiones virtuales resultará en la suspensión inmediata y permanente de la plataforma, así como la notificación a las autoridades competentes si procede. Al utilizar nuestros servicios, se compromete a mantener una conducta estrictamente profesional y respetuosa.`;

export function AvisoPoliticas({ onAceptar, onCerrar }) {
  const [marcado, setMarcado] = useState(false);
  const [verPol, setVerPol] = useState(false);

  if (verPol) return <PanelPoliticas onClose={() => setVerPol(false)} />;

  return (
    <Capa onCerrar={onCerrar} alta etiqueta="Políticas de uso">
      <div className="mdl avw" aria-labelledby="av-t" aria-describedby="av-d">
        <div className="avh">
          <div className="avicon" aria-hidden="true">!</div>
          <h4 id="av-t">Antes de enviar, lea esto</h4>
        </div>
        <div className="avb">
          <p className="avtexto" id="av-d">{TEXTO_POLITICA}</p>
          <div className="polalerta">
            <span className="polalerta-ic" aria-hidden="true">!</span>
            <div>
              <b>Expulsión permanente e inmediata</b>
              <span className="polalerta-desc">
                Detectar una solicitud de este tipo implica la expulsión inmediata y permanente de
                la plataforma, para el estudiante y para el tutor, sobre compra o venta de tareas,
                exámenes u otra actividad evaluativa.
              </span>
            </div>
          </div>
          <p className="avtexto">{TEXTO_ACOSO}</p>
          <div className="polalerta">
            <span className="polalerta-ic" aria-hidden="true">!</span>
            <div>
              <b>Expulsión permanente e inmediata</b>
              <span className="polalerta-desc">
                Cualquier caso de acoso, hostigamiento o conducta indebida expulsa
                permanentemente de la plataforma tanto al estudiante como al tutor, sin excepción.
              </span>
            </div>
          </div>

          <label className="avcheck">
            <input type="checkbox" checked={marcado}
              onChange={(e) => setMarcado(e.target.checked)} />
            <span>Leí y acepto las POLÍTICAS DE USO y las POLÍTICAS DE CANCELACIÓN Y DEVOLUCIÓN,
              y la Política de Cero Tolerancia al Acoso y Convivencia Segura de Ayudate.</span>
          </label>
          <p className="pie" style={{ marginTop: 10 }}>
            <button type="button" className="enlace-pol" onClick={() => setVerPol(true)}>
              Ver las políticas completas
            </button>
          </p>

          <div className="avacc">
            <button className="btn" onClick={onCerrar}>Volver</button>
            <button className="btn btn-p" disabled={!marcado} onClick={onAceptar}>
              {marcado ? "Acepto y envío" : "Marque la casilla"}
            </button>
          </div>
        </div>
      </div>
    </Capa>
  );
}

/* ==================================================================
   ACCESIBILIDAD
   Filtros de daltonización (no de simulación): desplazan el color que
   la persona no distingue hacia canales que sí percibe. Matrices
   derivadas de simular la deficiencia y devolver el error al resto
   del espectro.
================================================================== */

export function PanelPoliticas({ onClose }) {
  return (
    <Capa onCerrar={onClose} alta etiqueta="Nuestras políticas">
      <div className="mdl pol-mdl" aria-labelledby="pm-t">
        <div className="mdl-h">
          <div>
            <div className="anton" style={{ fontSize: 23 }} id="pm-t">Nuestras políticas</div>
            <div className="mt" style={{ marginTop: 4 }}>
              Puede cerrarlas y seguir donde iba: no se pierde nada de lo que llenó.
            </div>
          </div>
          <button className="x" onClick={onClose} aria-label="Cerrar las políticas">×</button>
        </div>

        <div className="mdl-b pol-b">
          <section>
            <span className="pm-n">01</span>
            <h5>Cancelación y devolución</h5>
            <p className="pm-cita">
              Puede cancelar en cualquier momento, se le va a cobrar un <b>FEE</b> de acuerdo al
              tiempo de aviso.
            </p>
            <div className="cancel2">
              <div className="cbox">
                <span className="ct">Para estudiantes</span>
                <ul>
                  <li>Con <b>más de 24 horas</b> de aviso, se le devuelve el <b>80%</b>.</li>
                  <li>Con <b>24 horas o menos</b>, se le devuelve el <b>60%</b>.</li>
                  <li>Si el tutor no se presenta, se le devuelve el <b>100%</b>.</li>
                </ul>
              </div>
              <div className="cbox">
                <span className="ct">Para tutores</span>
                <ul>
                  <li>Si el estudiante cancela con <b>más de 24 horas</b> de aviso, Ayudate retiene el 20%
                    por la gestión y el tutor no recibe nada de esa sesión.</li>
                  <li>Si el estudiante cancela con <b>24 horas o menos</b>, el tutor recibe un <b>20%</b> por
                    el horario que ya había bloqueado.</li>
                  <li>Si el tutor no se presenta, no recibe nada y se le devuelve el 100% al
                    estudiante.</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <span className="pm-n">02</span>
            <h5>Uso del servicio</h5>
            <p className="pm-cita">{TEXTO_POLITICA}</p>
            <div className="polalerta">
              <span className="polalerta-ic" aria-hidden="true">!</span>
              <div>
                <b>Expulsión permanente e inmediata</b>
                <span className="polalerta-desc">
                  Detectar una solicitud de este tipo implica la expulsión inmediata y permanente
                  de la plataforma, para el estudiante y para el tutor, sobre compra o venta de
                  tareas, exámenes u otra actividad evaluativa.
                </span>
              </div>
            </div>
            <ul className="check">
              <li>Sí: repasar temas, resolver ejercicios paso a paso, entender lo que no quedó claro.</li>
              <li>No: comprar o vender tareas, exámenes, proyectos o cualquier actividad evaluativa.</li>
            </ul>
          </section>

          <section>
            <span className="pm-n">03</span>
            <h5>Tutores</h5>
            <ul className="check">
              <li>En ciencias: comprobante de aprobación del curso con nota igual o superior
                a <b>80</b>.</li>
              <li>En idiomas: certificado que respalde el nivel declarado, de <b>B2<sup>+</sup></b>
                según el Marco Común Europeo. No se aceptan niveles por debajo de B2.</li>
              <li>En software: certificado, diploma o constancia laboral que respalde el nivel
                de conocimiento declarado en la herramienta.</li>
              <li>En preparación para el examen de admisión: el resultado oficial del examen,
                donde se vea la nota que obtuvo quien va a preparar a otros.</li>
              <li>Correo institucional vigente y respuesta en <b>menos de 24 horas</b>.</li>
              <li><b>Cada perfil lo revisa y aprueba un administrador</b>, nadie se publica solo.</li>
              <li>Las notas de los comprobantes no se publican ni las ve ningún estudiante.</li>
            </ul>
          </section>

          <section>
            <span className="pm-n">04</span>
            <h5>Cero tolerancia al acoso</h5>
            <p className="pm-cita">{TEXTO_ACOSO}</p>
            <div className="polalerta">
              <span className="polalerta-ic" aria-hidden="true">!</span>
              <div>
                <b>Expulsión permanente e inmediata</b>
                <span className="polalerta-desc">
                  Cualquier caso de acoso, hostigamiento o conducta indebida expulsa
                  permanentemente de la plataforma tanto al estudiante como al tutor, sin excepción.
                </span>
              </div>
            </div>
          </section>

          <p className="pm-datos">
            <b>Sus datos:</b> los usamos únicamente para coordinar la tutoría y comunicarnos con
            usted. <b>No los compartimos ni los vendemos</b>, y puede pedirnos que los borremos cuando
            quiera.
          </p>

          <button className="btn btn-p" style={{ width: "100%" }} onClick={onClose}>
            Entendido, volver al formulario
          </button>
        </div>
      </div>
    </Capa>
  );
}
